import * as ActionTypes from "../ActionTypes";

// ECMS Components Actions
export const GetECMSComponentsAction = (params) => {
    return {
        type: ActionTypes.ECMS_COMPONENTS_GET_REQUEST,
        params
    }
}

export const AddECMSComponentsAction = (params) => {
    return {
        type: ActionTypes.ECMS_COMPONENTS_ADD_REQUEST,
        params
    }
}

export const UpdateECMSComponentsAction = (params) => {
    return {
        type: ActionTypes.ECMS_COMPONENTS_UPDATE_REQUEST,
        params
    }
}

export const DeleteECMSComponentsAction = (params) => {
    return {
        type: ActionTypes.ECMS_COMPONENTS_DELETE_REQUEST,
        params
    }
}
